import BaseServiceCrud from './BaseServiceCrud';

export default class CardService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'cards';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            status: criteria.status,
            unauthorized: criteria.unauthorized,
            phone_number: criteria.phoneNumber,
            date_from: criteria.expirationDateFrom,
            date_to: criteria.expirationDateTo,
            text: criteria.text,
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    getFleetGoodGroups() {
        return this.fetch(`${this.domain}/${this.path}/fleet-good-group`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    updateMultipleCards(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/update-multiple-cards`, {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getUserInfo(id) {
        return this.fetch(`${this.domain}/${this.path}/user-info/${id}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    updateRequired(element) {
        return this.fetch(`${this.domain}/${this.path}/update-required`, {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    updateCardData(element) {
        return this.fetch(`${this.domain}/${this.path}/update-card-data`, {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    updateCardKind(element) {
        return this.fetch(`${this.domain}/${this.path}/update-card-kind`, {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    blockCard(id) {
        return this.fetch(`${this.domain}/${this.path}/block-card/${id}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    unblockCard(id) {
        return this.fetch(`${this.domain}/${this.path}/unblock-card/${id}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    renewCard(id, virtualOnly) {
        return this.fetch(`${this.domain}/${this.path}/card-renew/${id}`, {
            method: 'PUT',
          //  body: JSON.stringify(element),
            body: JSON.stringify(virtualOnly),

        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    renewCards(cards) {
        return this.fetch(`${this.domain}/${this.path}/cards-renew`, {
            method: 'PUT',
            body: JSON.stringify(cards),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    orderPlasticCard(id) {
        return this.fetch(`${this.domain}/${this.path}/order-plastic/${id}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    updateLimit(request) {
        return this.fetch(`${this.domain}/${this.path}/update-limit`, {
            method: 'PUT',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    updateVisitLimit(request) {
        return this.fetch(`${this.domain}/${this.path}/update-visit-limit`, {
            method: 'PUT',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    updateFuelsLimit(request) {
        return this.fetch(`${this.domain}/${this.path}/update-fuel-limits`, {
            method: 'PUT',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    updateProductsLimit(request) {
        return this.fetch(`${this.domain}/${this.path}/update-product-limits`, {
            method: 'PUT',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    updateServicesLimit(request) {
        return this.fetch(`${this.domain}/${this.path}/update-service-limits`, {
            method: 'PUT',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    updatePin(request) {
        return this.fetch(`${this.domain}/${this.path}/update-pin`, {
            method: 'PUT',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getCardOrderPrice() {
        return this.fetch(`${this.domain}/${this.path}/card-order-price`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    unauthorizeCard(cardNumber, phoneNumber) {
        return this.fetch(`${this.domain}/${this.path}/card-unauthorize`, {
            method: 'PUT',
            body: JSON.stringify({
                cardNumber,
                phoneNumber,
            }),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    authorizeCard(cardNumber, phoneNumber, accountRole, acceptedTerms) {
        return this.fetch(`${this.domain}/${this.path}/card-authorize`, {
            method: 'PUT',
            body: JSON.stringify({
                cardNumber,
                phoneNumber,
                accountRole,
                acceptedTerms
            }),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getCardDetailsImages() {
        return this.fetch(`${this.domain}/${this.path}/get-card-details-images`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    getCardDetailsRequired(cardNumber) {
        return this.fetch(`${this.domain}/${this.path}/requiredData/${cardNumber}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getHybridCardUserApprovalsToAccept() {
        return this.fetch(`${this.domain}/${this.path}/approvals/hybrid-card-user`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getHybridCardUserApprovalsToAcceptBeforeAuthorization() {
        return this.fetch(`${this.domain}/${this.path}/approvals/hybrid-card-user-authorize`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }


    highwayAction(request) {
        return this.fetch(`${this.domain}/${this.path}/highway`, {
            method: 'POST',
            body: JSON.stringify(request),
        });
    }

    updateHighwayData(request) {
        return this.fetch(`${this.domain}/${this.path}/update-highway-category`, {
            method: 'PUT',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    acceptTermsBeforeNextStep(element) {
        return this.fetch(`${this.domain}/${this.path}/hybrid-card-user/accept-terms`, {
            method: 'POST',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
